
import { onMounted, ref } from "vue";
import axios from "axios";
import { Driver } from "@/models/driver";
import moment from "moment";
import VPagination from "@hennge/vue3-pagination";
import "@hennge/vue3-pagination/dist/vue3-pagination.css";
import { useRoute } from "vue-router";

export default {
  name: "AdminDriverDetailList",
  components: { VPagination },
  methods: {
    dateTime(value: any) {
      return moment(value).format("DD-MMM-YYYY HH:mm");
    },
  },
  setup() {
    const riderearnings = ref([]);
    const riderwallets = ref([]);
    const riderloginlogs = ref([]);
    const ridercancelorderlogs = ref([]);
    const lastPage = ref(0);
    const rwlastPage = ref(0);
    const riderloginlastPage = ref(0);
    const ridercancellastPage = ref(0);
    const selected = ref(0);
    const search = ref("");
    const rider = ref([]);
    const route = useRoute();

    const load = async (page = 1) => {
      const { data } = await axios.get(
        `riderearnings/driver/${route.params.id}?page=${page}&take=50&search=${search.value}`
      );
      riderearnings.value = data.data;
      lastPage.value = data.meta.last_page;
    };

    onMounted(load);

    const rwload = async (rwpage = 1) => {
      const { data } = await axios.get(
        `riderwallet/driver/${route.params.id}?page=${rwpage}&take=50&search=${search.value}`
      );
      riderwallets.value = data.data;
      rwlastPage.value = data.meta.last_page;
    };

    onMounted(rwload);

  const driverloginlogload = async (rwpage = 1) => {
      const { data } = await axios.get(
        `driverloginlogs/driver/${route.params.id}?page=${rwpage}&take=50&search=${search.value}`
      );
      riderloginlogs.value = data.data;
      riderloginlastPage.value = data.meta.last_page;
    };

    onMounted(driverloginlogload);

  const ordercancellogload = async (rwpage = 1) => {
      const { data } = await axios.get(
        `order-cancel-log/driver/${route.params.id}?page=${rwpage}&take=50&search=${search.value}`
      );
      ridercancelorderlogs.value = data.data;
      ridercancellastPage.value = data.meta.last_page;
    };

    onMounted(ordercancellogload);


    const riderdata = async () => {
      const { data } = await axios.get(`drivers/${route.params.id}`);
      rider.value = data;
    };

    const select = (id: number) => {
      selected.value = selected.value !== id ? id : 0;
    };

    onMounted(riderdata);

    const del = async (id: number) => {
      if (confirm("Are You Sure?")) {
        //  await axios.delete(`riders/${id}`);

        riderearnings.value = riderearnings.value.filter(
          (u: Driver) => u.id !== id
        );
      }
    };

    const searchcall = async () => {
      load();
    };
    const searchclear = async () => {
      search.value = "";

      load();
    };
    return {
      riderearnings,
      riderloginlogs,
      ridercancelorderlogs,
      lastPage,
      rwlastPage,
      riderloginlastPage,
      ridercancellastPage,
      rider,
      del,
      search,
      load,
      rwload,
      ordercancellogload,
      driverloginlogload,
      selected,
      select,
      searchcall,
      searchclear,
      riderwallets,
    };
  },
};
